import { styled } from '@mui/material/styles'
import { FC } from 'react'
import { AppBarProps, AppBar as RaAppBar } from 'react-admin'
import { AppTile } from '../components/ui'
import OrganizationSwitcher from './OrganizationSwitcher'
import { themeColor } from './theme/color'
import { surface } from './theme/semanticTokens'
import { UserMenu } from './UserMenu'

// White header like xxllnc.ai: app tile + name left; org switcher, refresh and avatar right.
const AppBar: FC<AppBarProps> = (props) => (
  <StyledAppBar className={classes.root} container="div" elevation={0} userMenu={<UserMenu />} {...props}>
    <div className={classes.brand}>
      <AppTile abbreviation="Ce" color="orange" size={28} title="xxllnc Certificaten" />
      <span className={classes.name}>Certificaten</span>
    </div>
    <span className={classes.spacer} />
    <OrganizationSwitcher />
  </StyledAppBar>
)

const PREFIX = 'xxllncAppBar'

const classes = {
  root: `${PREFIX}-root`,
  spacer: `${PREFIX}-spacer`,
  brand: `${PREFIX}-brand`,
  name: `${PREFIX}-name`,
}

const StyledAppBar = styled(RaAppBar)(() => ({
  [`&.${classes.root}`]: {
    backgroundColor: surface.white,
    color: themeColor.slate60,
    borderBottom: '1px solid ' + themeColor.slate10,
  },
  ['& .RaAppBar-toolbar']: {
    height: 48,
    minHeight: 48,
  },
  ['& .RaAppBar-toolbar button svg']: {
    color: themeColor.slate60,
  },
  [`& .${classes.spacer}`]: {
    flex: 1,
  },
  [`& .${classes.brand}`]: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  [`& .${classes.name}`]: {
    color: themeColor.slate,
    fontSize: 13,
    fontWeight: 500,
  },
}))

export default AppBar
